import __request__ from "routing/request";
export function getLogGroupNames(JSONbody, requestOptions) {
  return __request__("POST", "/aws/cloudwatch/log_groups", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, setup_wizard = false, requestOptions) {
  return __request__("POST", "/aws/inputs", JSONbody, { "setup_wizard": setup_wizard }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function kinesisHealthCheck(JSONbody, requestOptions) {
  return __request__("POST", "/aws/kinesis/health_check", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getStreamArn(JSONbody, requestOptions) {
  return __request__("POST", "/aws/kinesis/stream_arn", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getKinesisStreams(JSONbody, requestOptions) {
  return __request__("POST", "/aws/kinesis/streams", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAwsRegions(requestOptions) {
  return __request__("GET", "/aws/regions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
